import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=34498a2e"
import script from "./packages.vue?vue&type=script&lang=js"
export * from "./packages.vue?vue&type=script&lang=js"
import style0 from "./packages.vue?vue&type=style&index=0&id=34498a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports